var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-card',{attrs:{"color":"primary"}},[_c('v-card-text',[_vm._t("default"),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }